import {
    Component,
    OnInit,
    ViewEncapsulation,
    Output,
    EventEmitter,
    HostBinding
} from '@angular/core';
import {
    FormGroup,
    FormControl,
    Validators
} from '@angular/forms';

@Component({
    selector: 'app-nw-server-form',
    templateUrl: './server-form.component.pug',
    styleUrls: ['./server-form.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ServerFormComponent implements OnInit {
    @HostBinding('class.--ui') _ui = true;

    @Output() connect: EventEmitter<IServer> = new EventEmitter<IServer>();

    public form: FormGroup = null;

    constructor(
    ) {
    }

    ngOnInit() {
        this._reset();
    }

    private _reset() {
        this.form = new FormGroup({
            isFavorite: new FormControl(false),

            name: new FormControl(''),

            settings: new FormGroup({
                host: new FormControl('', Validators.required),
                port: new FormControl(''),
                password: new FormControl(''),
                prefix: new FormControl('')
            })
        });
    }

    onFavorite(isFavorite) {
        this.form.controls.name.setValidators(isFavorite ? Validators.required : null);
        this.form.controls.name.updateValueAndValidity();
    }

    onSubmit($event) {
        $event.stopPropagation();

        const server: IServer = {
            ...this.form.value,

            apiUrl: `${ getUrl(this.form.value) }/api/`,
            websocketUrl: `${ getUrl(this.form.value) }/socket/`,
            prefix: 'local',
        };

        this.connect.emit(server);
        this._reset();
    }
}

function getUrl(server: IServer) {
    const { host, port } = server.settings;

    return `http://${ host }${ port ? (':' + port) : '' }`;
}
